<div class="cardform">
  <mat-card>
    <mat-card-content>
      <div class="step-content">
        <div class="review-details">
          <div class="review-section">
            <!-- <h3>Evento</h3> -->
            <p><strong>Evento:</strong> {{event?.name}}</p>
            <!-- <p><strong>Código:</strong> {{event?.uuid}}</p> -->
            <!-- <p><strong>Período:</strong> {{event?.startAt | date:'dd/MM/yyyy, HH:mm'}} até -->
              <!-- {{event?.endAt | date:'dd/MM/yyyy, HH:mm'}}</p> -->
          </div>
          <div class="review-section">
            <h3>Voluntário</h3>
            <!-- <p><strong>Nome Completo:</strong> {{volunteer?.nomeCompleto}}</p>
            <p><strong>CPF:</strong> {{volunteer?.cpf}}</p>
            <p><strong>Número Sistema:</strong> {{volunteer?.numeroSistema}}</p> -->
            <p><strong>Nome Colete:</strong> {{volunteer?.nomeColete}}</p>
            <p><strong>Comando Regional:</strong> {{volunteer?.comandoRegional}}</p>
            <p><strong>Regional:</strong> {{volunteer?.regional}}</p>
            <p><strong>Divisão:</strong> {{volunteer?.divisao}}</p>
            <p><strong>Cargo:</strong> {{volunteer?.cargo}}</p>
            <p><strong>Telefone:</strong> {{volunteer?.telefoneCelular}}</p>
          </div>
          <div class="review-section">
            <h3>Função</h3>
            <p><strong>Função:</strong> {{jobLocation?.description}}</p>
            <p><strong>Local:</strong> {{jobLocation?.name}}</p>
            <p><strong>Prioridade:</strong> {{jobLocation?.priority}}</p>
          </div>
        </div>
        <div class="review-section periodo">
          <h3>Período</h3>
          <form [formGroup]="dateTimeForm" class="datetime-form">
            <div class="datetime-fields">
              <mat-form-field>
                <mat-label>Data Inicial</mat-label>
                <input matInput
                       [matDatepicker]="startDatepicker"
                       formControlName="startDate"
                       [min]="today"
                       (dateChange)="autoSetEndDateTime()">
                <mat-datepicker #startDatepicker/>
                <mat-datepicker-toggle [for]="startDatepicker" matSuffix/>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Hora Inicial</mat-label>
                <input matInput
                       type="time"
                       formControlName="startTime"
                       (change)="autoSetEndDateTime()">
                <mat-icon matSuffix>schedule</mat-icon>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Data Final</mat-label>
                <input matInput
                       [matDatepicker]="endDatepicker"
                       formControlName="endDate"
                       [min]="getMinEndDate()"
                       (dateChange)="updateDurationOnChange()">
                <mat-datepicker #endDatepicker/>
                <mat-datepicker-toggle [for]="endDatepicker" matSuffix/>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Hora Final</mat-label>
                <input matInput
                       type="time"
                       formControlName="endTime"
                       (change)="updateDurationOnChange()">
                <mat-icon matSuffix>schedule</mat-icon>
              </mat-form-field>
              <div *ngIf="dateTimeForm.errors?.['dateRange']" class="validation-error">
                A data/hora de término deve ser posterior à data/hora de início
              </div>
            </div>
            <div class="duration-info">
              <mat-icon>schedule</mat-icon>
              <div class="duration-text">
                <span>Duração atual: {{formatDuration(currentDuration)}}</span>
              </div>
            </div>
          </form>
        </div>
        <div class="actions">
          <button mat-raised-button (click)="back.emit()">Voltar</button>
          <button mat-raised-button color="primary" (click)="confirmarCadastro()">Confirmar e Cadastrar</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
